rass-eotp {
  display: block;
  margin-bottom: 106px; // Must match the height of the #notification div
}

.cursor-pointer {
  cursor: pointer;
}

@media (min-width: 576px) {
  .checkbox-div {
    padding-top: 40px;
  }
}
